function isTouchPad(e) {
  return e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents;
}

function updateImagePosition(element, imageElement, e) {
  if (!isTouchPad(e)) {
    var x = e.pageX - element.offset().left;
    var y = e.pageY - element.offset().top;
    imageElement.css('left', x).css('top', y);
  }
}

$('.module--services__item').mousemove(function(e) {
  updateImagePosition($(this), $('.module--services__item__img'), e);
});

$('.module--short-cuts__items__item > div').mousemove(function(e) {
  updateImagePosition($(this), $('.module--short-cuts__items__item__img'), e);
});

// add the no-hover class when the mouse enters the sub-services
$('.sub-services').on('mouseover', function() {
  $('.service-hover').addClass('service-hover--no-hover');
});

// remove the no-hover class when the mouse leaves the sub-services
$('.sub-services').on('mouseleave', function() {
  $('.service-hover').removeClass('service-hover--no-hover');
});

// do not navigate to the parent link, but navigate to this data-index
$('.module--services__block__content__sub').on('click', function() {
  var index = $(this).attr('data-index');
  window.location.href=index;
  window.location.href = index;
  return false;
});
